export const formatPercent = (percent: number | null) =>
  new Intl.NumberFormat("pt-br").format(percent || 0)